var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"wave"}},[_c('span',{staticClass:"dot",class:'bg-' + _vm.variant}),_c('span',{staticClass:"dot",class:'bg-' + _vm.variant}),_c('span',{staticClass:"dot",class:'bg-' + _vm.variant})])
}
var staticRenderFns = []

export { render, staticRenderFns }